(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-subnav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.subnav[data-section-id]').forEach(function (nav) {
      var slot = nav.querySelector('.subnav__mobile-text');
      if (!slot) return;

      var sources = Array.from(nav.querySelectorAll('.subnav__item[data-subnav-mobile="rotate"]'))
        .map(function (item) {
          var link = item.querySelector('.subnav__link');
          return link ? { text: link.textContent.trim() } : null;
        })
        .filter(Boolean);

      if (!sources.length) {
        var center = slot.closest('.subnav__mobile-center');
        if (center) center.remove();
        return;
      }

      function render(source) {
        slot.textContent = source.text;
      }

      function show(source) {
        slot.classList.remove('is-entering');
        slot.classList.add('is-leaving');
        setTimeout(function () {
          render(source);
          slot.classList.remove('is-leaving');
          slot.classList.add('is-entering');
        }, 400);
      }

      render(sources[0]);
      if (sources.length < 2) return;

      var current = 0;
      setInterval(function () {
        current = (current + 1) % sources.length;
        show(sources[current]);
      }, 2500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
